import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { openCreateReviewModal } from 'Redux/Actions/createReviewActions';

const DashboardHeader = ({ title = 'Dashboard' }) => {
  const dispatch = useDispatch();

  const handleNewReview = () => {
    dispatch(openCreateReviewModal(null));
  };

  const reviewCount = useSelector(state => state.designReview.reviewCount);

  const isDisabled = useMemo(() => reviewCount.reviews_remaining <= 1, [reviewCount]);

  return (
    <header className="border-b border-gray-200 px-[16px] py-3">
      <div className="flex items-center justify-between h-10">
        {/* Left: logo/title */}
        <div className="flex items-center space-x-4">
          <h1 className="font-inter text-sm font-medium text-figma-gray-900 leading-5">
            {title}
          </h1>
        </div>

        {/* Right: help, menu button, avatar dropdown */}
        <div className="flex items-center space-x-4">
          <button
            onClick={isDisabled ? undefined : handleNewReview}
            disabled={isDisabled}
            className={`flex items-center justify-center px-3 py-2 font-inter
      text-sm font-medium rounded-lg shadow-shadow-xs transition-colors ${isDisabled
      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
      : 'bg-primary-500 text-white hover:bg-primary-600'}`}
          >
            New review
          </button>
        </div>
      </div>
    </header>
  );
};

DashboardHeader.propTypes = {
  title: PropTypes.string,
};

export default DashboardHeader;
